import { createBrowserRouter } from 'react-router-dom'
import App from './App'

// page d'erreur
import NotFound from './not-found'
import ConditionOfUse from './pages/CGU'
import LegalNotice from './pages/mentionsLegales'
import Accueil from './pages/Accueil'

export const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [
      {
        path: '/*',
        caseSensitive: true,
        element: <NotFound />,
      },
      {
        path: '/',
        element: <Accueil />,
      },
      {
        path: '/conditions-generales',
        caseSensitive: true,
        element: <ConditionOfUse />,
      },
      {
        path: '/mentions-legales',
        caseSensitive: true,
        element: <LegalNotice />,
      },
    ],
  },
])
